import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

/**
 * Custom hook to update report payment grid data when replenRPGridData changes.
 * @param {Array} replenRPGridData
 * @param {Array} reportPaymentGridData
 * @param {Function} setReportPaymentGridData
 * @param {Function} setShippingDetailsRP
 */
export function useReplenRPGridEffect({
  replenRPGridData,
  reportPaymentGridData,
  setReportPaymentGridData,
  setShippingDetailsRP,
}) {
  useEffectWithErrorLogging(() => {
    if (
      replenRPGridData.length > 0 &&
      replenRPGridData.some(
        (x) =>
          x.shippingDetails &&
          Object.keys(x.shippingDetails).length > 0
      )
    ) {
      const updatedObj = setShippingDetailsRP(
        reportPaymentGridData,
        replenRPGridData
      );
      setReportPaymentGridData(updatedObj);
    }
  }, [replenRPGridData]);
}
